<template>
  <div id="eventRightThree">
    <div class="title">
      <span>单位</span>
      <span>告警解决率</span>
      <span>告警数量</span>
    </div>
    <div class="content">
      <span>汉丰街道</span>
      <span>90%</span>
      <span>100</span>
    </div>
    <div class="content">
      <span>文峰街道</span>
      <span>85%</span>
      <span>80</span>
    </div>
    <div class="content">
      <span>云枫街道</span>
      <span>84%</span>
      <span>91</span>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({});
    const refData = toRefs(data);
    let mythreeechartsone;

    return { ...refData };
  }
});
</script>
<style lang="scss" scoped>
#eventRightThree {
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    color: #02bad3;
    height: 50px;
    background-color: #1a507a;
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
    }
  }
  .content {
    display: flex;
    flex: 1;
    align-items: center;
    // justify-content: space-around;
    color: #fff;
    background-color: #092956;
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
    }
  }
}
</style>
